export const toNamespacedKey = (...args: string[]) => args.join('/');
